import request from "@/utils/api/helpers";

const baseUrl = "/finance/currency-rates";

export const getCurrencyRates = () => request({
  url: baseUrl
});

export const getCurrencyRateById = (id) => request({
  url: `${baseUrl}/${id}`
});

export const createCurrencyRate = (data) => request({
  url: baseUrl,
  method: "POST",
  data
});

export const updateCurrencyRate = (id, data) => request({
  url: `${baseUrl}/${id}`,
  method: "PATCH",
  data
});

export const deleteCurrencyRate = (id) => request({
  url: `${baseUrl}/${id}`,
  method: "DELETE",
});
